import React from "react";
import Layout from "../shared/components/Layout";
import SubPageBanner from "../shared/sections/SubPageBanner";
import FeedbackSection from "../shared/sections/FeedbackSection";
import ClientBannerSection from "../shared/sections/ClientBannerSection";
import FAQSection from "../shared/sections/FAQSection";

const FAQ = () => {
	return (
		<Layout>
			<SubPageBanner title="Frequently asked questions" />
			<FAQSection isListPage />
			<FeedbackSection />
			<ClientBannerSection noHead />
		</Layout>
	);
};

export default FAQ;
